import './videoconference.ajscss';

import { IContactDeprecatedService } from '@agent/core/contact/contact-deprecated.service';
import { IComponentController, IComponentOptions, isDefined } from 'angular';

import { DisplayDeprecatedComponent } from '@contact/upgrade';

import { IVideoconferenceService } from './videoconference.service';
import templateUrl from './videoconference.template.html';

class VideoconferenceRequestCtrl extends DisplayDeprecatedComponent implements IComponentController {
  close: Function;
  dismiss: Function;

  targetPhone: string;
  selectedUsecase: IUsecase;
  usecases: IUsecase[];

  constructor(
    private readonly videoconferenceService: IVideoconferenceService,
    private readonly contactDeprecatedService: IContactDeprecatedService
  ) {
    super();
  }

  get phoneValid(): boolean {
    return isDefined(this.targetPhone) && this.targetPhone !== '' && this.isPhoneValid(this.targetPhone);
  }

  $onInit(): void {
    this.contactDeprecatedService.getSelectedContact().then(contact => {
      if (this.isPhoneValid(contact.phoneNumber)) {
        this.targetPhone = contact.phoneNumber;
      }
    });
    this.videoconferenceService.getUsecases().then(
      usecases => {
        this.usecases = usecases;
        if (usecases.length !== 0) {
          this.selectedUsecase = usecases[0];
        }
      },
      () => {
        this.usecases = [];
      }
    );
  }

  validate(): void {
    if (this.selectedUsecase) {
      this.videoconferenceService.sendCode(this.selectedUsecase.id, this.targetPhone);
    }
    this.close();
  }

  cancel(): void {
    this.dismiss();
  }

  private isPhoneValid(s): boolean {
    for (let i = 0; i < s.length; i++) {
      // Check that current character is valid.
      let c = s.charAt(i);
      if (c !== ' + ' && (c < '0' || c > '9')) {
        return false;
      }
    }
    // All characters are valid.
    return true;
  }
}

export class VideoconferenceRequest implements IComponentOptions {
  templateUrl = templateUrl;
  bindings = {
    // from ui-bootstrap modal
    close: '&',
    dismiss: '&',
  };
  controller = ['videoconference', 'contactDeprecatedService', VideoconferenceRequestCtrl];
}

export default 'videoconferenceRequest';
